import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ConnectionsReferenceService extends BaseReferenceService {
  constructor() {
    super('ConnectionsReference');
  }
}
